var map = {
	"./DataRestore": [
		37348,
		7348
	],
	"./DataRestore copy": [
		34827,
		4827
	],
	"./DataRestore copy.js": [
		34827,
		4827
	],
	"./DataRestore.js": [
		37348,
		7348
	],
	"./DataRestoreConfig0": [
		40921,
		921
	],
	"./DataRestoreConfig0.js": [
		40921,
		921
	],
	"./DataRestoreConfigEdit": [
		7192,
		7192
	],
	"./DataRestoreConfigEdit.js": [
		7192,
		7192
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 49252;
module.exports = webpackAsyncContext;